import React, { memo } from 'react';
import { InfoBanner } from '@modules/common/InfoBanner';

/**
 * Per-file upload limit on the live server (PHP `upload_max_filesize` = 2M on succeed-app-sf2x; the upload endpoint
 * itself sets no limit). Update this if the server limit is raised — every upload note reads it from here.
 */
export const MAX_UPLOAD_MB = 2;

const NOTES = {
  image: `JPG, PNG, WebP or GIF, up to ${MAX_UPLOAD_MB} MB per image. Large images make the proposal slow to load for your customer, so resize to about 1920px wide and compress before uploading. Library images are already optimised.`,
  pdf: `PDF only, one file, up to ${MAX_UPLOAD_MB} MB. Large PDFs take longer to open for your customer, so compress it before uploading if you can.`,
  video: 'Paste a video link (for example YouTube or Vimeo). Video files can’t be uploaded here. The video streams from that site, so it doesn’t slow the proposal down.',
};

export interface UploadNoteProps {
  kind: keyof typeof NOTES;
  className?: string;
  /** px below the note (InfoBanner always adds mb-4, so spacing goes through style). Default 8. */
  marginBottom?: number;
}

/** Info banner next to upload controls in the proposal builder: what's accepted and what slows proposals down. */
export const UploadNote = memo((props: UploadNoteProps) => (
  <InfoBanner
    intent="info"
    icon="fa-info-circle"
    className={props.className}
    // Regular weight (Badge text is bold by default) and explicit spacing
    style={{ fontWeight: 400, marginBottom: props.marginBottom ?? 8 }}
  >
    {NOTES[props.kind]}
  </InfoBanner>
));
